import React from 'react';
import {Box, IconButton, Tooltip} from '@mui/material';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import {grey} from "@mui/material/colors";

const styles = {
    container: {
        paddingLeft: '0.5rem',
        paddingBottom: '0.5rem'
    },
    iconButton: {
        padding: '0.25rem',
        border: '0.0625rem solid',
        borderColor: grey[300],
        borderRadius: '0.25rem',
    }
};

export default function PanelSwapToggle({isSwapped, onSwapToggle}) {
    return (
        <Box sx={styles.container}>
            <Tooltip title="Swap panel" placement="bottom">
                <IconButton
                    onClick={onSwapToggle}
                    aria-label="swap panel positions"
                    size="small"
                    sx={styles.iconButton}
                    color={isSwapped ? "primary" : "default"}>
                    <SwapVertIcon/>
                </IconButton>
            </Tooltip>
        </Box>
    );
}
